import { type ValidationRule } from '../../types';
import { ActionRequiredError } from '../../util/errors';

import { CanonicalStepRuleBase } from './base';

class ClassifyRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.Classify', 'Classify');
  }

  protected validate({ args }: any): void {
    this.checkFallback(args);
  }

  /**
   * Check if the fallback value is configured.
   * @param args - The arguments of the step.
   */
  private checkFallback(args: any): void {
    if (!args.fallbackValue) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Fallback value is not configured',
        fieldId: 'fallbackValue',
      });
    }
  }
}

export const ClassifyValidation: ValidationRule =
  new ClassifyRule().toValidationRule();
